import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Badge from 'Components/Badge/Badge.jsx';
import Button from 'Components/Button';
import CloseIcon from 'Components/icons/CloseIcon';
import DownArrowIcon from 'Components/icons/DownArrowIcon';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import LeftPointerIcon from 'Components/icons/left-pointer-icon/LeftPointerIcon';
import UpArrowIcon from 'Components/icons/UpArrowIcon';
import { customFormatclass, customClassCurrency } from 'Components/GDTable/GDCustomFormat/GDCustomFormat';
import GDCurrencyCodeCell from 'Components/GDTable/GDCurrencyCodeCell';
import GDDateCell from 'Components/GDTable/GDDateCell';
import GDAccountNumberCell from 'Components/GDTable/GDAccountNumberCell/GDAccountNumberCell';
import CardType from 'Components/CardType';
import GDTable from 'Components/GDTable';

import EmptyState from 'Components/EmptyState/EmptyState';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import OpenNewWindowIcon from 'Components/icons/OpenNewWindowIcon';
import counterpart from 'counterpart';
import './QuestionireDetailView.scss';

const buttonText = '';
const QuestionireDetailView = ({
  data,
  recordCountSize,
  selectedKeyIndex,
  extraClass,
  goToPreviousRecord,
  goToNextRecord,
  gotoExtraCaseDetailsPage,
  goBack,
  structure,
  type,
  preferences,
  isPrevBtnDisabled,
  isNextBtnDisabled,
  tableMetaData,
  dateFormat,
  pageHandler,
  handleSort,
  caseDataErr,
  isLoading,
  rowActionClick,
  translations,
  hideFlag,
  // gotoExtraCaseDetailsPage,
  configId,
  drawerdataErr,
  isdataLoading,
  isOperationsReport,
  isInternalUser,
  isMerchantUser,
  newTabToggle,
  isCitiUser
}) => {
    const wrapperClass = classnames('question-detail-view', {
      [extraClass]: extraClass,
    });
  
    let structure1 = [];
    structure1 = structure1.concat(structure[0]);
    let structure2 = [];
    structure2 = structure2.concat(structure[1]);
  
    function getItemData(item) {
      const itemKey = item.columnKey;
      let itemSpan = [];
      let checkData = [];
  
      if (item.displayType === 'STRING' || item.displayType === 'NUMBER' || item.displayType === 'TEXT') {
        return (
          <div>
           <span>{data[`${item.columnKey}`]}</span>
          </div>
        );
        }
        else if(item.displayType === 'BOOLEAN') {
          if(data[`${item.columnKey}`] === true){
            return (
              <div>
              <span>TRUE</span>
             </div>
              );
          }
          else if(data[`${item.columnKey}`] === false){
            return (
              <div>
              <span>FALSE</span>
             </div>
              );
          }
          else {
            return (
              <div>
              <span>--</span>
             </div>
              );
          }
         
        }
      return <span>--</span>;
    }
  
    function getCategories(structure) {
      if (type === 'report') {
        return (
          structure.map((category) => {
            document.body.style.overflow = 'hidden';
            let dataColumn1 = isCitiUser ? category.dataColumns?.filter(item => item.name !== 'Authorized') : category.dataColumns;
            return (
              <div className="question-detail-view__items-wrapper" key={category.categoryKey}>
                <div className="question-detail-view__items">
                  {dataColumn1.map((item) => {
                    if(item.displayType == 'STRING' || item.displayType == 'BOOLEAN') {
                      return item.name === 'STRING' || item.description === '' ? '' : (
                        <div className="question-detail-view__item" key={item.id}>
                          <span id={`${category.detailViewTitle}_GDDetailView_lbl_${item.name}`} className="question-detail-view__item-title">
                            {item.name} 
                            {item.descriptionKey && item.displayType === 'STRING' ? (	
                              <InformationBubble	
                                id={item.descriptionKey}	
                                info	
                                position	
                                tooltipContent={data[`${item.descriptionKey}`]}	
                              />	
                            ) : ( item.descriptionKey && 	
                                <InformationBubble	
                                  id={item.name}	
                                  info	
                                  position	
                                  tooltipContent={item.description}	
                                />	
                              )	
                            }
                          </span>
                          <span id={`${category.detailViewTitle}_GDDetailView_${item.name}_value_${data[`${item.columnKey}`]}`} className="question-detail-view__item-data">
                            {getItemData(item)}
                          </span>
                          <span class="divider"></span>
                        </div>
                      );
                    }
                    else {
                      return item.name === '' || item.description === '' ? '' : (
                        <div className="question-detail-view__item_text" key={item.id}>
                          <span id={`${category.detailViewTitle}_GDDetailView_lbl_${item.name}`} className="question-detail-view__item-title">
                            {item.name} 
                            {item.descriptionKey && item.displayType === 'STRING' ? (	
                              <InformationBubble	
                                id={item.descriptionKey}	
                                info	
                                position	
                                tooltipContent={data[`${item.descriptionKey}`]}	
                              />	
                            ) : ( item.descriptionKey && 	
                                <InformationBubble	
                                  id={item.name}	
                                  info	
                                  position	
                                  tooltipContent={item.description}	
                                />	
                              )	
                            }
                          </span>
                          <span id={`${category.detailViewTitle}_GDDetailView_${item.name}_value_${data[`${item.columnKey}`]}`} className="question-detail-view__item-data">
                            {getItemData(item)}
                          </span>
                          <span class="divider"></span>
                        </div>
                      );
                    }
                   
                  })}
                </div>
              </div>
            );
          })
        );
      }
    }
    return (
      <div className={wrapperClass}>
        <div className="question-detail-view__flex">
          <div className="question-detail-view__controls">
            <div className="question-detail-view__controls--left">
              <h2 className="question-detail-view__controls-title">
                {structure[0].returnToText}
              </h2>
            </div>
            <div className="question-detail-view__controls--right">
              {newTabToggle &&  type === 'caseLandingReport' && <div className="OpenNewWindowIcon"><div className="inner-div"><OpenNewWindowIcon
                onClick={() => gotoExtraCaseDetailsPage(1)}
              /></div>
              </div>}
              <Button
                id={`${structure[0].returnToText}_questionDetailView_btn_close`}
                action={goBack}
                category="toggled"
                iconDirection="left"
                icon={CloseIcon}
              >
                {buttonText}
              </Button>
            </div>
          </div>
          <div className="question-detail-view__scroller">
              {type === 'caseLandingReport' && (
                <div>  
                <div className="question-detail-view__section">
                  <div className="header"><div className="font-style" >{type === 'caseLandingReport' && structure[0].name}</div></div>
                  {getCategories(structure1)}</div>
                <div className="question-detail-view__section">
                  <div className="header"><div className="font-style" >{type === 'caseLandingReport' && structure[1].name}</div></div>
                  {getCategories(structure2)}</div>
              </div>
            )}
  
            {!isInternalUser && type === 'report' && (
              <div>
  
                <div className="question-detail-view__section">
                  {getCategories(structure)}</div>
              </div>
            )}
            {isInternalUser && type === 'report' && (	
              <div className="question-detail-view__section">	
              {isdataLoading === true &&<BVLoader20 />}	
              {!isdataLoading && !drawerdataErr && (	
                getCategories(structure))}	
                {drawerdataErr && !isdataLoading && (	
                  <EmptyState	
                    translations={{ emptyStateHeading: counterpart('globalTranslate.queues.emptyStateHeading'), emptyStateDescription: counterpart('globalTranslate.queues.emptyStateDescription') }}	
                  />	
                )	
                }	
            </div>	
            )}
          </div>
        </div>
      </div>
    );
  };

  QuestionireDetailView.propTypes = {

}

QuestionireDetailView.defaultProps = {
    data: {},
    extraClass: '',
    handleSort: () => { },
    pageHandler: () => { },
    structure: [],
    type: '',
    preferences: {},
    rowActionClick: () => { },
    translations: {},
    isInternalUser: true,
    isMerchantUser:false,
    newTabToggle: false,
  };
  
export default QuestionireDetailView;